export default __webpack_public_path__ + "648beff7f948d75c1bbcee2bccf0a2fa.png";